import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";


const ConfirmationDialog = ({ open, onClose, onConfirm, message }) => {
  const { t } = useTranslation("global")
  
  
    return (
      <Dialog className="sig_Drawer_SettingsModal_Root sig_BugReport_New_Root" open={open} onClose={onClose}>
        <DialogTitle className="sig_Drawer_SettingsModal_Title sig_Main_TitleWithIcon" > {t("strButton.confirmAction").toUpperCase()} </DialogTitle>
        <DialogContent className="sig_Drawer_SettingsModal_Content sig_BugReport_New_Content">
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="sig_FormDialog_Button sig_FormDialog_Button_Cancel" onClick={onClose}>
            {t("strButton.btn_cancel").toUpperCase()}
          </Button>
          <Button className="sig_FormDialog_Button sig_FormDialog_Button_Send" onClick={onConfirm}>
            {t("strButton.btn_accept").toUpperCase()}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ConfirmationDialog;